import type { ReactNode } from 'react';

/**
 * Renderiza markdown estilo WhatsApp: *negrito*, _itálico_, ~tachado~.
 * As quebras de linha (\n) são preservadas pelo container (whitespace-pre-wrap).
 */
export function renderWa(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  // marcadores de uma linha só (não cruzam \n): *negrito*, _itálico_, ~tachado~
  const regex = /(\*[^*\n]+\*|_[^_\n]+_|~[^~\n]+~)/g;
  let last = 0;
  let key = 0;
  for (const m of text.matchAll(regex)) {
    const idx = m.index ?? 0;
    if (idx > last) nodes.push(text.slice(last, idx));
    const tok = m[0];
    const inner = tok.slice(1, -1);
    if (tok[0] === '*') nodes.push(<strong key={key++}>{inner}</strong>);
    else if (tok[0] === '_') nodes.push(<em key={key++}>{inner}</em>);
    else nodes.push(<s key={key++}>{inner}</s>);
    last = idx + tok.length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}
